
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { authUser } from '../../interfaces';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { RadioButtonModule } from 'primeng/radiobutton';
import { Table, TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { TooltipModule } from 'primeng/tooltip';
import { DirectionService } from '../../services/direction.service';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { TabViewModule } from 'primeng/tabview';
import { StrategyService } from '../../services/strategy.service';
import { DropdownModule } from 'primeng/dropdown';
import { Strategy } from '../../interfaces/models/strategy.model';

import { NavTitlePipe } from '../../pipes/nav-title.pipe';

@Component({
  selector: 'app-tasks',
  standalone: true,
  imports: [
    NavTitlePipe,FormsModule, DropdownModule, RouterModule, TabViewModule, TableModule, TranslateModule, RadioButtonModule, ButtonModule, TooltipModule, TagModule, CommonModule],
  templateUrl: './tasks.component.html',
  styleUrl: './tasks.component.scss'
})
export class TasksComponent implements OnInit {
  @ViewChild('table') table!: Table;
  @ViewChild('dt') dt!: Table;
  monthly = false;
  strategyOptions = [] as { name: string, strategyId: number }[];
  user!: authUser;
  selectedStrategyId = 0;
  selectedStrategy = {} as Strategy;
  projects = [] as any;
  indicators = [] as any;
  dir!: 'rtl' | 'ltr';
  selectedPeriodOption = 'month'
  periodOptions = [{ label: "شهري", value: 'month' }, { label: 'اسبوعي', value: 'week' }] as any[];

  _activeIndex = 0;
  set activeIndex(value: number) {

    this._activeIndex = value;
    if (value == 1) {
      if (this.indicators.length) {
        if (!this.dt.isRowExpanded(this.indicators[0])) {
          this.dt.toggleRow(this.indicators[0]);
        }
      }
    } else {
      if (!this.dt.isRowExpanded(this.indicators[0])) {
        if (!this.table.isRowExpanded(this.projects[0])) {
          this.table.toggleRow(this.projects[0]);
        }
      }
    }
  }
  get activeIndex() {
    return this._activeIndex;
  }
  total_no_of_projects = 0;
  total_no_of_indicators = 0;

  constructor(
    private authService: AuthService,
    private directionService: DirectionService,
    private strategyService: StrategyService,
    private route: ActivatedRoute
  ) {
  }
  ngOnInit(): void {


    this.directionService.direction$.subscribe((dir) => {
      this.dir = dir;
    })

    this.authService.authBufferSub$.subscribe((user) => {
      this.user = user as authUser;
    });


    this.route.data.subscribe((data: any) => {
      this.GetTasks(data.viewBag.tasks.data)
      const strategies = data.viewBag.strategies
      if (this.selectedStrategyId == 0) {
        let defultStrategy = strategies.find((x: any) => x.is_default);
        this.selectedStrategyId = defultStrategy?.id || 0;
        this.selectedStrategy = defultStrategy as Strategy;
        this.strategyService.setStrategyIdfn(defultStrategy?.id || 0)
      }
      else {
        let Strategy = strategies.find((x: any) => x.id == this.selectedStrategyId);
        this.selectedStrategy = Strategy as Strategy;
        this.strategyService.setStrategyIdfn(this.selectedStrategyId)
      }
      this.strategyOptions = strategies.map((x: any) => ({ name: x.name, strategyId: x.id }))
    })


  };

  GetTasks(tasks: any) {
    this.projects = tasks.projects
    this.indicators = tasks.indicators
    this.total_no_of_projects = tasks.total_no_of_projects;
    this.total_no_of_indicators = tasks.total_no_of_indicators;
    if (this.projects?.length) {
      setTimeout(() => {
        this.table?.toggleRow(this.projects[0]); // Expand first row
      }, 100);
    }
  };

  onRowCollapse(event: any) {

  }
  onRowExpand(event: any) {

  }
  periodChange() {
    if (this.selectedPeriodOption == 'month') {
      this.monthly = true;
    } else {
      this.monthly = false;
    }
  }
  strategyOptionsChange() {
    this.strategyService.getStrategyById(this.selectedStrategyId.toString()).subscribe((strategy: any) => {
      this.selectedStrategy = strategy['data']['strategy'] as Strategy;

      this.strategyService.GetTasks(this.selectedStrategyId).subscribe((response: any) => {
        this.projects = response['data'].projects
        this.indicators = response['data'].indicators
        console.log("table", this.table);
        if (this.projects[0]) {
          this.table.toggleRow(this.projects[0]);
        }
        if (this.projects[1]) {
          this.table.toggleRow(this.projects[1]);
        }
      })
    })
  }
}
